'use strict'

// Init mobile menu and off-canvas
const mobileMenu = new MobileMenu()
document.addEventListener('mobilemenu-init-done', () => {
	var offCanvas = new OffCanvas({
		debug: false,
		overlay: true,
	})

	const searchWrap = document.getElementById('searchWrap')
	const searchClose = document.getElementById('searchClose')
	const searchInput = document.getElementById('se-form-offcanvas-input')

	// Event listeners for off-canvas
	offCanvas.mainWrap.addEventListener('open', e => {
		if (e.detail.bar.position == 'top') {
			searchWrap.classList.add('searchWrap--visible')
			searchClose.classList.add('searchClose--visible')

			searchInput.focus()
		}
	})

	offCanvas.mainWrap.addEventListener('close', e => {
		if (e.detail.bar.position == 'top') {
			searchWrap.classList.remove('searchWrap--visible')
			searchClose.classList.remove('searchClose--visible')
		}
	})
})

mobileMenu.init()

// Responsive tables
document.querySelectorAll('main > table').forEach((table) => {
	const tableWrapper = document.createElement('div')
	tableWrapper.classList.add('table-wrapper')
	tableWrapper.classList.add('overflow-x-auto')
	table.parentNode.insertBefore(tableWrapper, table)
	tableWrapper.appendChild(table)
})

// AJAX search
const searchForm = document.getElementById('se-form-offcanvas')
const searchInput = document.getElementById('se-form-offcanvas-input')
const resultsWrapElement = document.getElementById('searchResults')
const resultsElement = document.getElementById('searchResults__content')
var inputTimeout = null

searchForm.addEventListener('submit', function (e) {
	e.preventDefault()
})

searchInput.addEventListener('input', function (e) {
	clearTimeout(inputTimeout)

	var query = e.target.value

	if (query.length >= 3) {

		inputTimeout = setTimeout(function () {
			resultsWrapElement.classList.add('searchResults--loading')

			axios.get('/haku/', {
				headers: { 'X-Requested-With': 'XMLHttpRequest' },
				params: {
					q: e.target.value
				}
			}).then(function (response) {
				resultsElement.innerHTML = response.data
			}).catch(function (error) {
				console.log(error)
			}).finally(function () {
				resultsWrapElement.classList.remove('searchResults--loading')
			})
		}, 200)
	} else {
		resultsElement.innerHTML = ''
	}
})

// We might already have search query defined, so initially trigger search input
searchInput.dispatchEvent(new Event('input', {
	bubbles: true,
	cancelable: false,
}))
